var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-page"},[_c('div',{staticClass:"chart-row"},[_c('Chart',{attrs:{"name":"date"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }